import { Link } from "react-router-dom";
import { Badges, P, SVG } from "../../../AbstractElements";
// import { Href } from "../../../utils/Constant";
// import { Rating } from "react-simple-star-rating";
// import { dynamicImage } from "../../../Service";
import { TableColumn } from "react-data-table-component";
import { TicketListTableDataColumnType, TicketListTableTicket } from "../../../Types/Application/Ecommerce/Ecommerce";
import Swal from "sweetalert2";
import api from "../../../utils/api";

export const ticketListTableData = [
  {
    name: "Adult",
    ticket_price: 400.00,
    seasonal_price: 56000.0,
    seasonal_status: "Active",
  },
  {
    name: "Child111",
    ticket_price: 400.00,
    seasonal_price: 56000.0,
    seasonal_status: "Inactive",
  },
];

// const ProductListTableAction = ({adultPlanId}) => {
//   return (
//     <div className="product-action">
//       <Link to={Href}>
//         <SVG iconId="edit-content" style={{ fill: 'blue' }} />
//       </Link>
//       <button className="btn btn-sm">
//       <SVG iconId="trash1" style={{ fill: 'red' }}/>
//       </button>
//       <p>{adultPlanId}</p>
//     </div>
//   );
// };

const handleDelete = async (id: number) => {
  // Your delete logic here (API call, state update, etc.)
  // console.log("Deleting ID:", id);
  try {
    await api.delete(`/api/AdultPlan/DeleteAdultPlan?planId=${id}`);
    Swal.fire('Deleted!', 'The ticket plan has been deleted.', 'success');

    // Optional: refresh the list
    // setTicketListTableDatas((prev) => prev.filter((item) => item.adultPlanId !== id));
  } catch (error) {
    Swal.fire('Error!', 'Failed to delete the ticket plan.', 'error');
    console.error("Delete error:", error);
  }
};

interface ProductListTableActionProps {
  adultPlanId: any;
  onDelete: (id: number) => void;
}

export const ProductListTableAction: React.FC<ProductListTableActionProps> = ({ adultPlanId,  onDelete }) => {
  const editUrl = `/ticket/edit/${adultPlanId}`;

  const handleDeleteClick = () => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this ticket plan!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, delete it!',
    }).then((result) => {
      if (result.isConfirmed) {
        onDelete(adultPlanId);
        // Swal.fire('Deleted!', 'The ticket plan has been deleted.', 'success');
      }
    });
  };

  return (
    <div className="product-action d-flex gap-2">
      <Link to={editUrl}>
        <SVG iconId="edit-content" style={{ fill: 'blue' }} />
      </Link>
      <button className="btn btn-sm" onClick={handleDeleteClick}>
        <SVG iconId="trash1" style={{ fill: 'red' }} />
      </button>
    </div>
  );
};

export const ProductListTableProductName: React.FC<TicketListTableTicket> = ({ name }) => {
  return (
    <div className="product-names my-2">
      <P>{name}</P>
    </div>
  );
};

export const ProductListTableStatus :React.FC<TicketListTableTicket> = ({ name }) => {
  return (
    <Badges color="" className={`badge-light-${name === "Active" ? "secondary" : "primary" }`}>{name}</Badges>
  );
};

export const productListTableDataColumn: TableColumn<TicketListTableDataColumnType>[] = [
  {
    name: "Plan Name",
    cell: (row) => <ProductListTableProductName name={row.name}/>,
    sortable: true,
    grow: 2,
  },
  {
    name: "Ticket Price",
    selector: (row) => `${row.ticket_price}`,
    sortable: true,
  },
  {
    name: "Seasonal Price",
    selector: (row) => `${row.seasonal_price}`,
    sortable: true,
  },
  {
    name: "Seasonal Status",
    cell: (row) =>  <ProductListTableStatus name={row.seasonal_status} />,
  },
  {
    name: "Action",
    cell: (row) => <ProductListTableAction adultPlanId={row.adultPlanId} onDelete={handleDelete} />,
  },
];

  export const filtersData = [
    {
      name: "Choose Plan",
      options: ["Adult", "Child"],
    },
    {
      name: "Status",
      options: ["Active", "Inactive"],
    },
    {
      name: "Price",
      options: ["200.00", "300.00", "400.00", "500.00", "600.00"],
    },
  ];